<template>
    <th :class="className">
        <div class="row collapse no-pad align-bottom">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-text="label"></div>
        </div>
    </th>
</template>

<script>
    /**
    * Dependencies
    */
    import HelpText from '../HelpText'

    /**
     * Component
     */
    export default {
        name: 'table-header',
        components: {
            HelpText
        },
        props: {
            label: {
                type: String,
                required: false
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            helptext: {
                type: String,
                required: false,
                default: null
            }
        },
        computed: {
            className () {
                return {
                    'is-required': this.required
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/tables/TableHeader.vue